var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCareerPawternityLeave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512.001,
    height: 447.48,
    viewBox: "0 0 512.001 447.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pawternity_leave",
    "data-name": "Pawternity leave",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19417",
    "data-name": "Path 19417",
    d: "M342.383,239.352a124.666,124.666,0,0,0-209.926,0L76.941,325.958a78.91,78.91,0,0,0,98.191,114.824l1.047-.465a155.123,155.123,0,0,1,123.52.465,78.475,78.475,0,0,0,31.664,6.7,79.476,79.476,0,0,0,17.664-2A78.92,78.92,0,0,0,397.9,325.954Zm0,0",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19418",
    "data-name": "Path 19418",
    d: "M91.895,239.238c16.516-6.344,29.063-19.652,35.328-37.477,5.965-16.961,5.477-36.109-1.379-53.922s-19.336-32.332-35.133-40.922C74.117,97.9,55.887,96.429,39.4,102.785,6.226,115.539-9,156.531,5.469,194.183c11.555,29.969,38.5,48.887,65.75,48.887a57.316,57.316,0,0,0,20.676-3.832Zm0,0",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19419",
    "data-name": "Path 19419",
    d: "M199.613,171.387c41.469,0,75.207-38.437,75.207-85.684S241.082,0,199.613,0s-75.2,38.445-75.2,85.7S158.148,171.387,199.613,171.387Zm0,0",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19420",
    "data-name": "Path 19420",
    d: "M329.5,192.438h0a61.3,61.3,0,0,0,19.367,3.129c30.242,0,59.715-22.012,70.961-55.84,6.477-19.473,6.051-40.062-1.2-57.973C411.043,63,396.984,49.4,379.039,43.43s-37.359-3.477-54.66,7c-16.527,10.008-29.191,26.246-35.66,45.719-13.652,41.078,4.641,84.273,40.777,96.289Zm0,0",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19421",
    "data-name": "Path 19421",
    d: "M487.875,182.438l-.012-.012c-28.6-21.125-71.367-11.969-95.348,20.422-23.957,32.406-20.211,75.973,8.344,97.113a58.793,58.793,0,0,0,35.313,11.4c21.949,0,44.785-11.2,60.051-31.8,23.953-32.406,20.211-75.973-8.348-97.121Zm0,0",
    fill: "#7dbaab"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerPawternityLeave);
export default __webpack_public_path__ + "static/media/Career-Pawternity-leave.2418aafeae99f425d8764d60571e0b5b.svg";
export { ForwardRef as ReactComponent };